import { ReactElement  } from "react"; 
import Modal from '@components/Modal';
import { getLabelFallback } from "@utils/utils";

import PrivateLock from '@images/svg-icons/private-lock.svg';
import MouseClick  from '@images/svg-icons/mouse-click.svg';
import CreditCard from '@images/svg-icons/credit-card-payment.svg';

type PayPalModalProps = {
    close: () => void;
}

const PayPalModal = (props: PayPalModalProps) : ReactElement => {
    const {
        close
    } = props;

    return(
        <div className="paypal-modal">
            <Modal close={close}>
                <h2 className="paypal-modal-title">
                    { getLabelFallback('PAYPAL_MODAL_TITLE') }
                </h2>
                <label className="paypal-modal-claim">
                    { getLabelFallback('PAYPAL_MODAL_CLAIM')}
                </label>
                <div className="paypal-modal-content">
                    <div className="paypal-modal-content-image">
                        <PrivateLock width={'64px'} height={'64px'}/>
                    </div>
                    <div className="paypal-modal-content-right">
                        <h3 className="paypal-modal-content-right-title">{ getLabelFallback('PAYPAL_MODAL_FIRST_PARAGRAPH_TITLE') }</h3>
                        <label className="paypal-modal-content-right-text">{ getLabelFallback('PAYPAL_MODAL_FIRST_PARAGRAPH_TEXT') }</label>
                    </div>
                </div>
                <div className="paypal-modal-content">
                    <div className="paypal-modal-content-image">
                        <CreditCard width={'64px'} height={'64px'}/>
                    </div>
                    <div className="paypal-modal-content-right">
                        <h3 className="paypal-modal-content-right-title">{ getLabelFallback('PAYPAL_MODAL_SECOND_PARAGRAPH_TITLE') }</h3>
                        <label className="paypal-modal-content-right-text">{ getLabelFallback('PAYPAL_MODAL_SECOND_PARAGRAPH_TEXT') }</label>
                    </div>
                </div>
                <div className="paypal-modal-content">
                    <div className="paypal-modal-content-image">
                        <MouseClick width={'64px'} height={'64px'}/>
                    </div>
                    <div className="paypal-modal-content-right">
                        <h3 className="paypal-modal-content-right-title">{ getLabelFallback('PAYPAL_MODAL_THIRD_PARAGRAPH_TITLE') }</h3>
                        <label className="paypal-modal-content-right-text">{ getLabelFallback('PAYPAL_MODAL_THIRD_PARAGRAPH_TEXT') }</label>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default PayPalModal;